import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useAuth from "../../Hooks/useAuth";

export const Navbar = ({ onToggleSidebar, username }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [ppColor, setPpcolor] = useState("");
    const [profileMenu, setProfileMenu] = useState(false);

    const randomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const handleLogout = () => {
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Sesi anda akan di hapus. Anda akan login ulang setelah logout!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, Logout!",
            cancelButtonText: "Tidak, Batal!",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-red-500 text-white hover:bg-red-600",
                cancelButton: "bg-gray-300 text-black hover:bg-gray-400",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                logout();
                navigate("/login");
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "sesi anda masih tersimpan", "error");
            }
        });
    };

    useEffect(() => {
        setPpcolor(randomColor());
    }, []);

    return (
        <div className="flex items-center justify-start gap-3 bg-blue-100 shadow-sm shadow-slate-300  px-4 h-14">
            <button
                className="lg:hidden text-blue-700 font-bold flex items-center justify-center text-lg"
                onClick={onToggleSidebar}>
                <span className="material-symbols-outlined">menu</span>
            </button>
            <h3 className="text-blue-700 font-bold">Dashboard</h3>
            <div
                style={{ marginLeft: "auto" }}
                className="flex flex-row justify-center items-center gap-3">
                <h3 className="text-blue-700">{username}</h3>
                <img
                    alt="logo"
                    onClick={() => setProfileMenu(!profileMenu)}
                    className="w-8 rounded-full cursor-pointer"
                    src={`https://eu.ui-avatars.com/api/?name=${username}&size=250&background=${ppColor}&color=fff&length=1`}></img>
            </div>
            <div
                className={`${
                    profileMenu ? "translate-x-0" : "translate-x-full"
                } fixed top-[60px] transform duration-300 ease-in-out right-1 w-[190px] shadow-sm shadow-slate-300 bg-blue-100 rounded-sm p-2`}>
                <button
                    onClick={handleLogout}
                    className="text-red-500 font-semibold hover:bg-blue-200 p-2 w-full text-left rounded-sm flex items-center gap-2 transform duration-300 ease-in-out">
                    <span className="material-symbols-outlined">logout</span>{" "}
                    Logout
                </button>
            </div>
        </div>
    );
};
